module.exports = __webpack_public_path__ + "ma.581173bdafc79a24bd6a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ma.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ma.svg
// module chunks = styles